import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, LinearProgress, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { AppSnackbar } from '@sierralabs/core-ui';
import { useTruncateEntity } from '../hooks/useTruncateEntity';
const StyledDialogContent = styled(DialogContent) `
  .content {
    margin-bottom: 8px;
  }
  .entity-list {
    padding-left: 28px;
  }
  .MuiAlertTitle-root {
    font-size: 15px;
    font-weight: 600;
  }
`;
const TruncateEntityDialog = props => {
    const { open, entity, onCancel, onTruncate } = props;
    const onTruncateRef = useRef(onTruncate);
    const [cascade, setCascade] = useState(false);
    const [error, setError] = useState();
    const [snackbarError, setSnackbarError] = useState();
    const { isTruncating, truncateError, response, truncate } = useTruncateEntity(entity.id || '');
    const isTruncateError = error &&
        error.statusCode === 409 &&
        error.error === 'Truncate Conflict' &&
        Array.isArray(error.entities);
    const relatedLength = error && Array.isArray(error.entities) ? error.entities.length : 0;
    // disable closing if truncating
    const onClose = () => !isTruncating && (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
    const renderEntity = (v) => (React.createElement(React.Fragment, null,
        React.createElement("strong", null, v.name),
        " (table: ",
        React.createElement("strong", null, v.tableName),
        ")"));
    useEffect(() => {
        onTruncateRef.current = onTruncate;
    }, [onTruncate]);
    // reset values
    useEffect(() => {
        if (open) {
            setCascade(false);
            setError(undefined);
        }
    }, [open]);
    useEffect(() => {
        var _a;
        if (response === null || response === void 0 ? void 0 : response.ok) {
            (_a = onTruncateRef.current) === null || _a === void 0 ? void 0 : _a.call(onTruncateRef);
        }
    }, [response]);
    useEffect(() => {
        if (truncateError) {
            setError(truncateError);
            setSnackbarError(truncateError);
        }
    }, [truncateError]);
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        isTruncating && React.createElement(LinearProgress, null),
        React.createElement(DialogTitle, null,
            "Truncate \"",
            entity.name,
            "\" Entity"),
        React.createElement(StyledDialogContent, null,
            error && isTruncateError && (React.createElement(Alert, { severity: 'error', className: 'content' },
                React.createElement(AlertTitle, null, error.error),
                React.createElement(Typography, { variant: 'body2' },
                    error.message,
                    " You can choose to truncate with the",
                    ' ',
                    React.createElement("strong", null, "CASCADE"),
                    " option by checking the box below."))),
            error && isTruncateError && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: 'body2', className: 'content' },
                    "Listed below are the entities that reference this entity. Note that if ",
                    React.createElement("strong", null, "CASCADE"),
                    " is checked, these entities will also be included in the ",
                    React.createElement("strong", null, "TRUNCATE"),
                    "."),
                React.createElement("ul", { className: 'entity-list' }, (error.entities || []).map((entity, index) => (React.createElement("li", { key: `${entity.tableName}-${index}` },
                    React.createElement(Typography, { variant: 'body2' }, renderEntity(entity)))))),
                React.createElement(FormControlLabel, { className: 'content', label: React.createElement(Typography, { variant: 'body2' },
                        "Enable ",
                        React.createElement("strong", null, "TRUNCATE CASCADE")), control: React.createElement(Checkbox, { color: 'primary', checked: cascade, disabled: isTruncating, onChange: () => setCascade(!cascade) }) }))),
            React.createElement(Typography, { variant: 'body2', className: 'content' },
                "Are you sure you want to ",
                React.createElement("strong", null, "TRUNCATE"),
                " entity",
                ' ',
                renderEntity(entity),
                " and",
                ' ',
                !(cascade && error && isTruncateError) ? ('all of its content?') : (React.createElement(React.Fragment, null,
                    React.createElement("strong", null,
                        relatedLength,
                        " other",
                        ' ',
                        relatedLength === 1 ? 'entity' : 'entities'),
                    ' ',
                    "listed above?")),
                ' ',
                "This action is ",
                React.createElement("strong", null, "IRREVERSIBLE"),
                " and may result in data loss.")),
        React.createElement(DialogActions, null,
            React.createElement(Button, { disabled: isTruncating, onClick: onClose }, "Cancel"),
            React.createElement(Button, { color: 'primary', variant: 'contained', disabled: isTruncating, onClick: () => truncate(cascade) },
                "Confirm TRUNCATE",
                cascade && ' CASCADE')),
        React.createElement(AppSnackbar, { severity: 'error', open: !!snackbarError, onClose: () => setSnackbarError(undefined) }, snackbarError === null || snackbarError === void 0 ? void 0 : snackbarError.message)));
};
export default TruncateEntityDialog;
//# sourceMappingURL=TruncateEntityDialog.js.map